<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from "vue";

const isVisible = ref(false);

const handleScroll = () => {
  // Show after user scrolls 400px
  isVisible.value = window.scrollY > 400;
};

const scrollToTop = () => {
  // Smooth scroll is also enabled globally via CSS, this ensures programmatic smoothness
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  handleScroll();
  window.addEventListener("scroll", handleScroll, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-4"
  >
    <button
      v-if="isVisible"
      type="button"
      @click="scrollToTop"
      aria-label="Back to top"
      class="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center rounded-full shadow-lg ring-1 ring-primary-main/20 bg-gradient-to-br from-primary-main to-primary-dark text-white hover:from-primary-dark hover:to-primary-dark hover:shadow-xl focus:outline-none h-12 w-12"
    >
      <!-- Up arrow icon to match theme -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="h-6 w-6"
      >
        <path
          fill-rule="evenodd"
          d="M11.47 3.97a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 1 1-1.06 1.06L12.75 6.31V20a.75.75 0 0 1-1.5 0V6.31L5.78 11.78a.75.75 0 1 1-1.06-1.06l6.75-6.75Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </transition>
</template>

<style scoped>
/* Ensure high contrast when overlapping content */
.shadow-lg {
  box-shadow:
    0 10px 15px -3px rgb(106 13 173 / 0.25),
    0 4px 6px -4px rgb(106 13 173 / 0.15);
}
</style>
